<template>
  <vi-page>
    <vi-card no-header>
      <VCDataTable v-bind="dtable" @e-row-action="eRowAction">
        <template v-slot:table_col_shiyunBill="scope">
          <template v-if="scope.row.shiyunBill">
            {{ eGetShiyunBill(scope.row.shiyunBill.userSN) }}
          </template>
        </template>
        <template v-slot:table_col_shiyunBillType="scope">
          <template v-if="scope.row.shiyunBill">
            {{ eGetShiyunBillType(scope.row.shiyunBill.type) }}
          </template>
        </template>
        <template v-slot:table_col_originalAmount="scope">
          <vi-amount v-model="scope.row.originalAmount" :prefix="prefix" />
        </template>
        <template v-slot:table_col_amount="scope">
          <vi-amount v-model="scope.row.amount" :prefix="prefix" />
        </template>
        <template v-slot:table_col_commissionAmount="scope">
          <span class="text-success">
            <vi-amount v-model="scope.row.commissionAmount" :prefix="prefix"
          /></span>
        </template>
        <template v-slot:table_col_status="scope">
          <span v-if="scope.row.status === 'Paid'" class="text-success">
            {{ eGetCommissionBillStatus(scope.row.status) }}
          </span>
          <span v-else>
            {{ eGetCommissionBillStatus(scope.row.status) }}
          </span>
        </template>
        <template v-slot:header-bottom>
          <div class="ml-4">
            <div class="row">
              <!-- <div class="row col-lg-3 col-sm-6 align-items-center">
                <span>所属客户：</span>
                <div class="select_width">
                  <vi-selector v-model="custmoerSN" :options="custmoerList">
                  </vi-selector>
                </div>
              </div> -->
              <div class="row col-lg-3 col-sm-6 align-items-center">
                <span>状态：</span>
                <div class="select_width">
                  <vi-selector v-model="status" :options="statusList">
                  </vi-selector>
                </div>
              </div>
              <div class="col-lg-4 col-sm-6 row align-items-center">
                <span>结算时间范围：</span>
                <div>
                  <vi-date-picker range v-model="range"></vi-date-picker>
                </div>
              </div>
              <button
                type="reset"
                class="btn btn-primary mt-2"
                @click="eFilter"
              >
                搜索
              </button>
            </div>
          </div>
        </template>
      </VCDataTable>
      <CommissionbillDetail
        v-if="commissionbillData.addable"
        v-model="commissionbillData.showAdd"
        :commissionbillData="commissionbillData"
        @input="ecommissionbillModalCancel"
        @e-cancel="ecommissionbillModalCancel"
      ></CommissionbillDetail>
    </vi-card>
  </vi-page>
</template>
<script>
import VCDataTable from "@leiweb/kernel-dashboard/src/controls/data/DataTable";
import CommissionbillDetail from "./bill/Detail";
export default {
  name: "PageAgentCommissionbill",
  components: {
    VCDataTable,
    CommissionbillDetail,
  },
  data() {
    return {
      dtable: {
        label: "我的返佣",
        url: "/shiyun/marketing/apis/data/commissionbill",
        orderBy: { name: "ID", type: "Desc" },
        params: [`sn == SN-0`],
        fields: [
          { name: "sn", type: "sn", table: { hidden: true } },
          {
            name: "shiyunBillSN",
            type: "text",
            label: "来源账单号",
          },
          {
            name: "shiyunBill.*",
            type: "text",
            label: "时云账单",
            table: { hidden: true },
          },
          {
            name: "shiyunBill",
            type: "slot",
            label: "所属客户",
          },
          {
            name: "name",
            type: "text",
            label: "账单概要",
          },
          {
            name: "shiyunBillType",
            source: "shiyunBill.Type",
            type: "slot",
            label: "类型",
          },
          {
            name: "originalAmount",
            type: "slot",
            label: "原价",
          },
          {
            name: "amount",
            type: "slot",
            label: "应付金额",
          },
          {
            name: "commissionType",
            type: "select",
            label: "返佣模式",
            options: [
              { value: "ProductAmount", label: "产品原价" },
              { value: "PaymentAmount", label: "产品支付金额" },
            ],
          },
          {
            name: "commissionAmount",
            type: "slot",
            label: "获取佣金",
          },
          {
            name: "status",
            type: "slot",
            label: "状态",
          },
          {
            name: "time",
            type: "date",
            format: "YYYY-MM-DD HH:mm:ss",
            label: "结算时间",
          },
        ],
        add: {
          enable: false,
        },
        edit: {
          enable: false,
        },
        remove: {
          enable: false,
        },
        rowActions: [{ name: "base", icon: "fas:bars", tips: "详情" }],
      },
      agentSN: "",
      range: [],
      custmoerSN: "all",
      custmoerList: [{ label: "全部", value: "all" }],
      commissionbillData: {
        addable: false,
        showAdd: false,
        sn: "",
      },
      status: "all",
      statusList: [
        { label: "全部", value: "all" },
        { label: "未支付", value: "New" },
        { label: "已支付", value: "Paid" },
        { label: "取消", value: "Canceled" },
        { label: "作废", value: "Remove" },
      ],
    };
  },
  computed: {
    user() {
      return this.$$.store.getters.currentUser;
    },
  },
  watch: {
    user() {
      this.eSetParam();
      this.eGetAgent();
    },
  },
  mounted() {
    if (this.user.sn) {
      this.eSetParam();
      this.eGetAgent();
    }
    this.prefix = this.$$.currency.prefix();
  },
  methods: {
    eRowAction(action, row) {
      if (action.name === "base") {
        this.commissionbillData.sn = row.sn;
        this.commissionbillData.addable = true;
        this.commissionbillData.showAdd = true;
      }
    },
    eGetAgent() {
      this.$$.api.data
        .find("/shiyun/marketing/apis/data/agent", {
          columns: ["*"],
          requirement: {
            filters: [{ Name: "userSN", Type: "Equal", Value: this.user.sn }],
          },
        })
        .then((res) => {
          let agent = res.data.item;
          this.eGetCustomerList(agent);
        })
        .catch(() => {});
    },
    eSetParam() {
      this.dtable.params = [`userSN == ${this.user.sn}`];
    },
    eGetCustomerList(agent) {
      this.$$.api.data
        .list("/shiyun/aliyun/apis/data/customer", {
          requirement: {
            filters: [{ Name: "agentSN", Type: "Equal", Value: agent.sn }],
          },
          columns: ["userSN", "name"],
        })
        .then((res) => {
          let data = res.data.list;
          data.map((p) => {
            this.custmoerList.push({ label: p.name, value: p.userSN });
          });
        });
    },
    eFilter() {
      this.dtable.params = [`userSN == ${this.user.sn}`];

      //   if (this.custmoerSN && this.custmoerSN != "all") {
      //      this.dtable.params.push(`shiyunBill.userSN== ${this.custmoerSN}`);
      //   }
      if (this.status && this.status != "all") {
        this.dtable.params.push(`status == ${this.status}`);
      }

      if (!this.range || this.range.length !== 2) {
        return;
      }
      this.dtable.params.push(`Time >= ${this.range[0]}`);
      if (this.range[0] === this.range[1]) {
        let date = new Date(this.range[0]);
        date = date.setDate(date.getDate() + 1);

        this.dtable.params.push(`Time < ${date}`);
      } else {
        this.dtable.params.push(`Time <= ${this.range[1]}`);
      }
    },
    ecommissionbillModalCancel() {
      this.commissionbillData.addable = false;
      this.commissionbillData.showAdd = false;
    },
    eGetCommissionBillStatus(status) {
      let result = "";
      switch (status) {
        case "New":
          result = "未支付";
          break;
        case "Paid":
          result = "已支付";
          break;
        case "Canceled":
          result = "取消";
          break;
        case "Remove":
          result = "作废";
          break;
        default:
          result = "未知";
      }
      return result;
    },
    eGetstatus(status) {
      let result = "";
      switch (status) {
        case "New":
          result = "新订单";
          break;
        case "Paid":
          result = "已支付";
          break;
        case "Canceled":
          result = "已取消";
          break;
        case "Remove":
          result = "废弃";
          break;
        case "WaitPay":
          result = "待支付";
          break;
        default:
          result = "未知";
      }
      return result;
    },
    eGetShiyunBillType(status) {
      let result = "";
      switch (status) {
        case "Prepay":
          result = "预付费";
          break;
        case "Postpay":
          result = "后付费";
          break;
        case "Refund":
          result = "退款";
          break;
        case "Adjustment":
          result = "调账";
          break;
        default:
          result = "未知";
      }
      return result;
    },
    eGetShiyunBill(val) {
      let find = this.custmoerList.find((p) => p.value == val);
      if (find) {
        return find.label;
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
.bill_select {
  display: flex;
  flex-wrap: wrap;
}
.select_width {
  width: 170px;
}
.date_width {
  width: 200px;
}
.date_margin {
  margin: 0 5px;
}
.row_p {
  position: relative;
  .m_condition {
    position: absolute;
    right: 5px;
    top: 5px;
    display: flex;
    align-items: center;
    i {
      padding-bottom: unset;
    }
  }
}
</style>
